import React, { useState, useEffect, useContext, useMemo } from "react";

import * as Yup from "yup";
import {
    Formik,
    Form
    // FieldArray // ✅ REMOVIDO: No se usa
} from "formik";
import { toast } from "react-toastify";

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    // Grid, // ✅ REMOVIDO: No se usa
    makeStyles,
    useTheme,
    TextField,
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip,
    IconButton,
    Paper,
    Tooltip
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
// import AttachFileIcon from "@material-ui/icons/AttachFile"; // ✅ REMOVIDO: No se usa
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import ImageIcon from "@material-ui/icons/Image";

import { green } from "@material-ui/core/colors";

import { i18n } from "../../translate/i18n";

import {
  findFileListById,
  createFileList,
  updateFileList,
  uploadFileListMedia,
  deleteFileOption,
} from "../../services/files.api";
import toastError from "../../errors/toastError";
import { describirErrorSubida } from "../../helpers/mensajeErrorSubida";
import { AuthContext } from "../../context/Auth/AuthContext";

import { useStyles } from "./FileModalStyles";

const initialState = {
    name: "",
    message: "",
    options: [],
};

const FilesModal = ({ open, onClose, fileListId, reload }) => {
    const classes = useStyles();
    const theme = useTheme();
    const { user } = useContext(AuthContext);
    const [selectedFileNames, setSelectedFileNames] = useState([]);
    const [dragActive, setDragActive] = useState(false);

    const fileListSchema = useMemo(
        () =>
            Yup.object().shape({
                name: Yup.string()
                    .min(3, i18n.t("fileModal.validation.nameMin"))
                    .required(i18n.t("fileModal.validation.required")),
                message: Yup.string()
                    .required(i18n.t("fileModal.validation.required"))
            }),
        [i18n.language],
    );
    
    // ✅ Variables no utilizadas removidas para evitar warnings

    // ✅ FUNCIONES DE UTILIDAD PARA ARCHIVOS
    const getFileIcon = (fileName, file = null) => {
        const extension = fileName.split('.').pop().toLowerCase();
        
        // ✅ MOSTRAR MINIATURA REAL PARA IMÁGENES
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
            if (file && file.file) {
                // ✅ IMAGEN LOCAL - mostrar preview
                return (
                    <img 
                        src={URL.createObjectURL(file.file)}
                        alt={fileName}
                        style={{
                            width: 40,
                            height: 40,
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: `2px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                            boxShadow: theme.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                    />
                );
            } else if (file && file.path && fileListId) {
                // ✅ IMAGEN SUBIDA - mostrar desde servidor
                const backendUrl = window.WATOOLX_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
                return (
                    <img 
                        src={`${backendUrl}/public/fileList/${fileListId}/${file.path}`}
                        alt={fileName}
                        style={{
                            width: 40,
                            height: 40,
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: `2px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                            boxShadow: theme.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                        onError={(e) => {
                            // ✅ FALLBACK: Si falla la carga, mostrar icono genérico
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />
                );
            } else {
                // ✅ FALLBACK: Mostrar icono genérico para imágenes
                return <ImageIcon className={`${classes.fileIcon} ${classes.fileIconImage}`} />;
            }
        }
        
        // ✅ ICONOS PARA OTROS TIPOS DE ARCHIVO
        if (['pdf'].includes(extension)) {
            return <PictureAsPdfIcon className={`${classes.fileIcon} ${classes.fileIconPdf}`} />;
        } else if (['doc', 'docx'].includes(extension)) {
            return <DescriptionIcon className={`${classes.fileIcon} ${classes.fileIconDoc}`} />;
        } else if (['mp4', 'avi', 'mov', 'wmv', 'flv'].includes(extension)) {
            return <VideoLibraryIcon className={`${classes.fileIcon} ${classes.fileIconVideo}`} />;
        } else if (['mp3', 'wav', 'flac', 'aac'].includes(extension)) {
            return <MusicNoteIcon className={`${classes.fileIcon} ${classes.fileIconAudio}`} />;
        } else {
            return <InsertDriveFileIcon className={`${classes.fileIcon} ${classes.fileIconDefault}`} />;
        }
    };

    const getFileFormat = (fileName) => {
        return fileName.split('.').pop().toUpperCase();
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return `0 ${i18n.t("fileModal.fileSize.bytes")}`;
        const k = 1024;
        const sizes = [
            i18n.t("fileModal.fileSize.bytes"),
            i18n.t("fileModal.fileSize.kb"),
            i18n.t("fileModal.fileSize.mb"),
            i18n.t("fileModal.fileSize.gb"),
        ];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    // ✅ FUNCIONES DE DRAG & DROP
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setDragActive(true);
        }
    };

    const handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
    };

    const handleDrop = (e, setFieldValue, values) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFiles(e.dataTransfer.files, setFieldValue, values);
        }
    };

    const handleFiles = (fileList, setFieldValue, values) => {
        const newFiles = Array.from(fileList).map(file => ({
            name: file.name,
            file: file,
            mediaType: file.type,
            size: file.size,
            path: file.name,
            id: `temp_${Date.now()}_${Math.random()}` // ✅ ID TEMPORAL ÚNICO
        }));

        // ✅ ACTUALIZAR SOLO EL ESTADO DE FORMIK
        const updatedOptions = [...(values.options || []), ...newFiles];
        setFieldValue('options', updatedOptions);
        
        // ✅ Archivos agregados exitosamente

        setSelectedFileNames(prev => [...prev, ...Array.from(fileList).map(f => f.name)]);
    };

    // ✅ USEEFFECT PARA CARGAR DATOS CUANDO SE EDITA UNA LISTA EXISTENTE
    const [loadedData, setLoadedData] = useState(null);
    
    useEffect(() => {
        if (fileListId && open && !loadedData) {
            (async () => {
                try {
                    const { data } = await findFileListById(fileListId);
                    // ✅ Datos cargados para edición
                    setLoadedData(data);
                    setSelectedFileNames(data.options?.map(opt => opt.name || opt.path) || []);
                } catch (err) {
                    toastError(err);
                }
            })();
        }
    }, [fileListId, open, loadedData]);

    // ✅ RESETEAR loadedData CUANDO SE CIERRA EL MODAL
    useEffect(() => {
        if (!open) {
            setLoadedData(null);
        }
    }, [open]);

    // ✅ REMOVER EL USEEFFECT DUPLICADO

    const handleClose = () => {
        // ✅ NO LIMPIAR EL ESTADO DEL FORMULARIO AQUÍ
        // La limpieza se maneja automáticamente por Formik
        setSelectedFileNames([]);
        setDragActive(false);
        onClose();
    };

    const handleSaveFileList = async (values) => {
        const uploadFiles = async (filesOptions, id) => {
            const formData = new FormData();
            formData.append("fileId", id);
            formData.append("typeArch", "fileList")
            filesOptions.forEach((fileOption) => {
                if (fileOption.file) {
                    formData.append("files", fileOption.file);
                    formData.append("mediaType", fileOption.file.type)
                    formData.append("name", fileOption.name);
                }
            });

            // No avisa aquí: quien llama decide el mensaje (la lista ya está guardada y el usuario
            // tiene que saber que ESTE archivo no subió, no ver «guardado» y «error» a la vez).
            try {
                const { data } = await uploadFileListMedia(id, formData);
                return { ok: true, data };
            } catch (err) {
                return { ok: false, err };
            }
        }

        // ✅ FILTRAR ARCHIVOS TEMPORALES PARA ENVIAR AL BACKEND
        const filesToSave = values.options.filter(option => !option.id || !String(option.id).startsWith('temp_'));
        const newFilesToUpload = values.options.filter(option => option.id && String(option.id).startsWith('temp_'));
        
        // ✅ CREAR LISTA SIN ARCHIVOS NUEVOS (solo con archivos existentes)
        const fileData = { 
            ...values, 
            userId: user.id,
            options: filesToSave // ✅ Solo archivos ya guardados
        };
        
        try {
            let currentFileListId = fileListId;
            if (currentFileListId) {
                // ✅ EDITAR LISTA EXISTENTE
                await updateFileList(currentFileListId, fileData);
            } else {
                // ✅ CREAR NUEVA LISTA
                const { data } = await createFileList(fileData);
                currentFileListId = data.id;
            }
            
            // ✅ SUBIR ARCHIVOS NUEVOS DESPUÉS DE CREAR/ACTUALIZAR LA LISTA
            if (newFilesToUpload.length > 0) {
                const subida = await uploadFiles(newFilesToUpload, currentFileListId);
                if (!subida.ok) {
                    // La lista SÍ quedó guardada; los archivos nuevos no. Un solo aviso que lo diga,
                    // con qué archivo y por qué (antes: «guardada correctamente» + «error inesperado»).
                    const archivos = newFilesToUpload.map((o) => o.file).filter(Boolean);
                    const nombres = archivos.map((a) => a.name).join(", ");
                    toast.error(
                        `La lista «${values.name || ""}» se guardó, pero no se pudo subir: ${nombres}. ` +
                        describirErrorSubida(subida.err, archivos),
                        { autoClose: 15000 }
                    );
                    if (typeof reload == "function") reload();
                    onClose();
                    return;
                }
            }
            
            toast.success(i18n.t("fileModal.success"));
            if (typeof reload == 'function') {
                reload();
            }
            // ✅ NO LIMPIAR FORMULARIO - solo cerrar modal
            onClose();
        } catch (err) {
            toastError(err);
        }
    };

    return (
        <div className={classes.root}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth={false}
                scroll="paper"
                PaperProps={{
                    style: {
                        width: '900px',
                        maxWidth: '95vw',
                        borderRadius: '12px',
                        boxShadow: theme.mode === 'dark' ? '0 8px 32px rgba(0,0,0,0.5)' : '0 8px 32px rgba(0,0,0,0.12)',
                        backgroundColor: theme.palette.background.paper,
                    }
                }}>
                <DialogTitle id="form-dialog-title" style={{ backgroundColor: theme.palette.primary.main, color: 'white' }}>
                    {(fileListId ? `${i18n.t("fileModal.title.edit")}` : `${i18n.t("fileModal.title.add")}`)}
                </DialogTitle>
                <Formik
                    initialValues={loadedData || initialState}
                    enableReinitialize={true}
                    validationSchema={fileListSchema}
                    onSubmit={(values, actions) => {
                        setTimeout(() => {
                            handleSaveFileList(values);
                            actions.setSubmitting(false);
                        }, 400);
                    }}
                >
                    {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                        <Form>
                            <DialogContent dividers style={{ padding: '16px 24px', backgroundColor: theme.palette.background.paper }}>
                                {/* ✅ CAMPOS BÁSICOS */}
                                <div className={classes.multFieldLine}>
                                    <TextField
                                        label={i18n.t("fileModal.form.name")}
                                        name="name"
                                        value={values.name || ""}
                                        onChange={(e) => setFieldValue('name', e.target.value)}
                                        error={touched.name && Boolean(errors.name)}
                                        helperText={touched.name && errors.name}
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        className={classes.textField}
                                    />
                                </div>
                                <div className={classes.multFieldLine} style={{ marginTop: '16px' }}>
                                    <TextField
                                        label={i18n.t("fileModal.form.message")}
                                        multiline
                                        minRows={2}
                                        fullWidth
                                        name="message"
                                        value={values.message || ""}
                                        onChange={(e) => setFieldValue('message', e.target.value)}
                                        error={touched.message && Boolean(errors.message)}
                                        helperText={touched.message && errors.message}
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textField}
                                    />
                                </div>

                                {/* ✅ DRAG & DROP ZONE */}
                                <Typography
                                    style={{ marginBottom: 8, marginTop: 16, color: theme.palette.text.primary }}
                                    variant="subtitle1"
                                >
                                    {i18n.t("fileModal.dragDrop.sectionTitle")}
                                </Typography>

                                <Box
                                    className={`${classes.dragDropZone} ${dragActive ? 'dragActive' : ''}`}
                                    onDragEnter={handleDragIn}
                                    onDragLeave={handleDragOut}
                                    onDragOver={handleDrag}
                                    onDrop={(e) => handleDrop(e, setFieldValue, values)}
                                    onClick={() => document.getElementById('file-input-modal').click()}
                                >
                                    <CloudUploadIcon className={classes.dragDropIcon} />
                                    <Typography variant="body1" className={classes.dragDropText}>
                                        {i18n.t("fileModal.dragDrop.main")}
                                    </Typography>
                                    <Typography variant="body2" className={classes.dragDropSubtext}>
                                        {i18n.t("fileModal.dragDrop.sub")}
                                    </Typography>
                                    <Typography variant="caption" className={classes.dragDropSubtext}>
                                        {i18n.t("fileModal.dragDrop.formats")}
                                    </Typography>
                                    <input
                                        id="file-input-modal"
                                        type="file"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFiles(e.target.files, setFieldValue, values)}
                                    />
                                </Box>

                                {/* ✅ TABLA DE ARCHIVOS CON 6 COLUMNAS */}
                                {values.options && values.options.length > 0 && (
                                    <Paper className={classes.filesTable}>
                                        <Table size="small" style={{ tableLayout: 'fixed', width: '100%' }}>
                                            <TableHead>
                                                <TableRow className={classes.tableHeader}>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '100px' }}>{i18n.t("fileModal.table.thumbnail")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '300px', minWidth: '300px' }}>{i18n.t("fileModal.table.name")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '100px' }}>{i18n.t("fileModal.table.format")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '120px' }}>{i18n.t("fileModal.table.size")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} style={{ width: '100px' }}>{i18n.t("fileModal.table.type")}</TableCell>
                                                    <TableCell className={classes.tableHeaderCell} align="center" style={{ width: '100px' }}>{i18n.t("fileModal.table.actions")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {values.options.map((file, index) => (
                                                <TableRow key={index} className={classes.tableRow}>
                                                        <TableCell style={{ width: '100px', overflow: 'hidden' }}>
                                                            {getFileIcon(file.name || file.path, file)}
                                                        </TableCell>
                                                        <TableCell style={{ width: '300px', minWidth: '300px', overflow: 'hidden' }}>
                                                            <Tooltip 
                                                                title={file.name || file.path}
                                                                placement="top"
                                                                arrow
                                                            >
                                                                <Typography 
                                                                    variant="body2" 
                                                                    noWrap
                                    style={{ 
                                        cursor: 'pointer', 
                                        color: theme.palette.primary.main,
                                        textDecoration: 'underline',
                                        maxWidth: '280px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}
                                                                    onClick={() => {
                                                                        // ✅ CONSTRUIR URL CORRECTA DEL ARCHIVO
                                                                        const backendUrl = window.WATOOLX_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
                                                                        let fileUrl;
                                                                        
                                                                        if (file.path && fileListId) {
                                                                            // ✅ ARCHIVO YA SUBIDO - usar ruta del servidor
                                                                            fileUrl = `${backendUrl}/public/fileList/${fileListId}/${file.path}`;
                                                                        } else if (file.file) {
                                                                            // ✅ ARCHIVO LOCAL - crear URL temporal
                                                                            fileUrl = URL.createObjectURL(file.file);
                                                                        }
                                                                        
                                                                        if (fileUrl) {
                                                                            window.open(fileUrl, '_blank', 'noopener,noreferrer');
                                                                        } else {
                                                                            console.warn('No se pudo determinar la URL del archivo:', file);
                                                                        }
                                                                    }}
                                                                >
                                                                    {file.name || file.path}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell style={{ width: '100px', overflow: 'hidden' }}>
                                                            <Chip 
                                                                label={getFileFormat(file.name || file.path)} 
                                                                size="small"
                                                                className={classes.formatChip}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ width: '120px', overflow: 'hidden' }}>
                                                            <Typography className={classes.sizeText}>
                                                                {file.size ? formatFileSize(file.size) : 
                                                                 file.file?.size ? formatFileSize(file.file.size) : 
                                                                 'N/A'}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell style={{ width: '100px', overflow: 'hidden' }}>
                                                            <Tooltip 
                                                                title={file.mediaType || 'N/A'}
                                                                placement="top"
                                                                arrow
                                                            >
                                                                <Typography 
                                                                    className={classes.sizeText}
                                                                    style={{
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        maxWidth: '90px'
                                                                    }}
                                                                >
                                                                    {file.mediaType || 'N/A'}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell align="center" style={{ width: '100px', overflow: 'hidden' }}>
                                                            <IconButton
                                                                size="small"
                                                                onClick={async () => {
                                                                    try {
                                                                        // ✅ Eliminando archivo
                                                                        
                                                                        // ✅ ELIMINAR ARCHIVO INDIVIDUAL DEL BACKEND SI TIENE ID REAL
                                                                        if (file.id && fileListId && !String(file.id).startsWith('temp_')) {
                                                                            await deleteFileOption(fileListId, file.id);
                                                                            // ✅ Archivo eliminado del servidor
                                                                        } else {
                                                                            // ✅ Archivo temporal, solo eliminando del frontend
                                                                        }
                                                                        
                                                                        // ✅ ELIMINAR DEL FRONTEND DE FORMA MÁS ROBUSTA
                                                                        const newOptions = values.options.filter((_, i) => i !== index);
                                                                        setFieldValue('options', newOptions);
                                                                        
                                                                        const newFileNames = selectedFileNames.filter((_, i) => i !== index);
                                                                        setSelectedFileNames(newFileNames);
                                                                        
                                                                        // ✅ NO NECESITAMOS ACTUALIZAR ESTADO LOCAL
                                                                        // Formik ya maneja el estado
                                                                        
                                                                        // ✅ Archivo eliminado de la interfaz
                                                                    } catch (error) {
                                                                        console.error(`❌ Error eliminando archivo ${file.name}:`, error);
                                                                        toast.error(`Error eliminando archivo: ${error.message}`);
                                                                    }
                                                                }}
                                                                title={i18n.t("fileModal.tooltips.removeFile")}
                                                                style={{
                                                                    backgroundColor: '#f44336',
                                                                    color: 'white',
                                                                    margin: '0 4px',
                                                                    padding: '8px',
                                                                    borderRadius: '50%',
                                                                    minWidth: '32px',
                                                                    minHeight: '32px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.backgroundColor = '#d32f2f';
                                                                    e.target.style.transform = 'scale(1.1)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.backgroundColor = '#f44336';
                                                                    e.target.style.transform = 'scale(1)';
                                                                }}
                                                            >
                                                                <DeleteOutlineIcon style={{ fontSize: '18px' }} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                )}
                            </DialogContent>
                            <DialogActions style={{ backgroundColor: theme.palette.background.paper, borderTop: `1px solid ${theme.mode === 'dark' ? '#374151' : '#e0e0e0'}` }}>
                                <Button
                                    onClick={handleClose}
                                    color="secondary"
                                    disabled={isSubmitting}
                                    variant="outlined"
                                >
                                    {i18n.t("fileModal.buttons.cancel")}
                                </Button>
                                <Button
                                    type="submit"
                                    color="primary"
                                    disabled={isSubmitting}
                                    variant="contained"
                                    className={classes.btnWrapper}
                                >
                                    {fileListId
                                        ? `${i18n.t("fileModal.buttons.okEdit")}`
                                        : `${i18n.t("fileModal.buttons.okAdd")}`}
                                    {isSubmitting && (
                                        <CircularProgress
                                            size={24}
                                            className={classes.buttonProgress}
                                        />
                                    )}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </div>
    );
};

export default FilesModal;